module.exports = __webpack_public_path__ + "static/media/students-icon-3.d8924dfb.svg";